import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoCardComponent } from './info-card/info-card.component';
import { ListCardComponent } from './list-card/list-card.component';
import { ItemComponent } from './list-card/item/item.component';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '../button/button.module';
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG
} from 'ngx-perfect-scrollbar';
import { AppPipesModule } from '../../pipes/app-pipes/app-pipes.module';

@NgModule({
  declarations: [InfoCardComponent, ListCardComponent, ItemComponent],
    exports: [InfoCardComponent, ListCardComponent, ItemComponent],
  imports: [
    CommonModule,
    RouterModule,
    PerfectScrollbarModule,
    ButtonModule,

    // pipes
    AppPipesModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: {
        suppressScrollX: true
      }
    }
  ]
})
export class CardsModule {}
